// NPM Plugins
import { Timer } from 'easytimer.js';
import { W8ShippingAPIClient } from './modules-custom/W8_ShippingAPIClient';

// Some Usefull Functions
import { moneyFormat, lazyLoadGalleryLot } from './modules-custom/functions';

let controller = new AbortController();
const calculatedEvent = new CustomEvent('calculated');
const client = new W8ShippingAPIClient(
  theme.api.endpointW8,
  theme.api.nonce,
  theme.i18n.locale_pll,
);

if (document.querySelector('[data-start-values]') && window.wp.i18n) {
  const { _n } = window.wp.i18n;
  const timer = new Timer();

  document.getElementById('sec').style.width =
    document.getElementById('sec').offsetWidth + 'px';

  timer.start({
    countdown: true,
    startValues: JSON.parse(
      document.querySelector('[data-start-values]').dataset.startValues,
    ),
  });

  timer.addEventListener('secondsUpdated', function () {
    document.getElementById('countdown-days').innerHTML =
      timer.getTimeValues().days;
    document.getElementById('countdown-hours').innerHTML =
      timer.getTimeValues().hours;
    document.getElementById('countdown-minutes').innerHTML =
      timer.getTimeValues().minutes;
    document.getElementById('countdown-seconds').innerHTML =
      timer.getTimeValues().seconds;

    document.getElementById('countdown-string-days').innerHTML = _n(
      'day',
      'days',
      timer.getTimeValues().days,
      'w8-shipping-front',
    );
    document.getElementById('countdown-string-hours').innerHTML = _n(
      'hour',
      'hours',
      timer.getTimeValues().hours,
      'w8-shipping-front',
    );
    document.getElementById('countdown-string-minutes').innerHTML = _n(
      'minute',
      'minutes',
      timer.getTimeValues().minutes,
      'w8-shipping-front',
    );
    document.getElementById('countdown-string-seconds').innerHTML = _n(
      'second',
      'seconds',
      timer.getTimeValues().seconds,
      'w8-shipping-front',
    );
  });

  timer.addEventListener('targetAchieved', function () {
    document.querySelector('[data-countdown]').style.display = 'none';
    document.querySelector('[data-countdow-achieved]').style.display = 'block';
  });
}

async function handleInputChange(value, el, array) {
  if (moneyFormat.from(value) < +el.dataset.min) {
    return false;
  }

  // Синхронізація значень у всіх інпутах
  array.forEach((inputEl) => (inputEl.value = value));

  // Оновити налаштування
  document.getElementById('currentBid').innerHTML = value;

  const formData = new FormData();
  const args = JSON.parse(document.querySelector('[data-calc]').dataset.calc);
  for (const key in args) {
    if (Object.prototype.hasOwnProperty.call(args, key)) {
      const element = args[key];
      formData.append(key, element);
    }
  }
  formData.append('costOfTheCar', moneyFormat.from(value));

  client.post('calculator', {
    body: { ...Object.fromEntries(formData), country: 'ua' },
    loadingElements: document.querySelectorAll('[data-loading-element]'),
    signal: controller.signal,
    onSuccess: ({ calculations, html }) => {
      // Разом ціна автомобіля з доставкою та розмитненням
      document
        .querySelectorAll('[data-total-price]')
        .forEach((el) => (el.innerHTML = calculations.value_formatted));

      document.getElementById('calculations').innerHTML = html.lot;
      setInputBidHandler();
      document.dispatchEvent(calculatedEvent);
    },
  });
}

function setInputBidHandler() {
  document.querySelectorAll('[data-input-bid]').forEach((el, index, array) => {
    if (el.inputBidHandlerSeted) {
      return false;
    }
    el.addEventListener('blur', () => handleInputChange(el.value, el, array));
    el.inputBidHandlerSeted = true;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // начать наблюдение
  setInputBidHandler();

  if (document.getElementById('related_lots')) {
    setTimeout(async () => {
      client.post('getRelatedLots', {
        body: { lot_id: theme.page.id },
        onSuccess: ({ lots }) => {
          const swiper = document.getElementById('related_lots').swiper;
          swiper.removeAllSlides();
          lots?.forEach((lot) => {
            swiper.appendSlide(`<div class="swiper-slide">${lot}</div>`);
          });
          swiper.update();
          const event = new CustomEvent('related-lots-loaded');
          document.dispatchEvent(event);
        },
      });
    }, 1000);
  }

  lazyLoadGalleryLot();

  const showAvaregePriceBtn = document.getElementById('showAvaregePrice');
  showAvaregePriceBtn?.addEventListener('click', async () => {
    const parentWrap = showAvaregePriceBtn.parentElement;

    client.post('getAveragePrice', {
      body: { lot_id: theme.page.id },
      loadingElements: [showAvaregePriceBtn],
      onSuccess: ({ average_price }) => {
        showAvaregePriceBtn.remove();
        parentWrap.insertAdjacentHTML(
          'afterbegin',
          `<span id="averagePrice">${average_price}</span>`,
        );
        const inputs = document.querySelectorAll('[data-input-bid]');
        if (inputs.length) {
          inputs.forEach((el) => {
            el.value = average_price.replace(/s[^0-9]/, '');
            el.mask.unmaskedValue = average_price.replace(/s[^0-9]/, '');
          });
          handleInputChange(average_price, inputs[0], inputs);
        }
      },
      onError: ({ message }) => {
        showAvaregePriceBtn.remove();
        parentWrap.insertAdjacentHTML(
          'afterbegin',
          `<span class="text-red-error">${message}</span>`,
        );
      },
    });
  });
});
